<template lang="pug">
.conbox
	.tabbox
		.panelbox
			.panel-holder
				.resbox
					.resbox-cus-tabs
						.ctabs.aaa(dd='dp') {{$t('ui.deposit')}}
						router-link.ctabs(to='withdrawal') {{$t('ui.withdrawal')}}
					.resbox-con
						.resbox-cusbox.dp.aaa
							.resbox-tabs.payment-mode
								ul.nav.nav-tabs(role='tablist')
									template(v-for="gateway in bankModeList")
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'gcash'" @click="changeTab(0)")
											button#gcash-tab.nav-link(:class="{'active' : selectedTab === 0}" data-bs-toggle='tab' data-bs-target='#gcash' type='button' role='tab' aria-controls='gcash' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 0}" src="assets/img/GCash.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'gcashqr'" @click="changeTab(1)")
											button#gcashqr-tab.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#gcashqr' type='button' role='tab' aria-controls='gcashqr' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 1}" src="assets/img/GCash.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'maya'" @click="changeTab(2)")
											button#maya-tab.nav-link(:class="{'active' : selectedTab === 2}" data-bs-toggle='tab' data-bs-target='#maya' type='button' role='tab' aria-controls='maya' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 2}" src="assets/img/Maya.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'grabpay'" @click="changeTab(3)")
											button#grabpay-tab.nav-link(:class="{'active' : selectedTab === 3}" data-bs-toggle='tab' data-bs-target='#grabpay' type='button' role='tab' aria-controls='grabpay' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 3}" src="assets/img/grab.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'usdt'" @click="changeTab(4)")
											button#usdt-tab.nav-link(:class="{'active' : selectedTab === 4}" data-bs-toggle='tab' data-bs-target='#usdt' type='button' role='tab' aria-controls='usdt' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 4}" src="assets/img/usdt.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'bank'" @click="changeTab(5)")
											button#bank-tab.nav-link(:class="{'active' : selectedTab === 5}" data-bs-toggle='tab' data-bs-target='#bank' type='button' role='tab' aria-controls='bank' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 5}" src="assets/img/bank.png" style="width:50px") 
												span {{gateway.payment_desc}}
										li.nav-item(role='presentation' v-if="gateway.payment_mode === 'qrph'" @click="changeTab(6)")
											button#qrph-tab.nav-link(:class="{'active' : selectedTab === 6}" data-bs-toggle='tab' data-bs-target='#qrph' type='button' role='tab' aria-controls='qrph' aria-selected='false') 
												img.mb-2(:class="{'grayscale': selectedTab !== 6}" src="assets/img/qrph.png" style="width:50px") 
												span {{gateway.payment_desc}}
								//- ul.nav.nav-tabs(role='tablist')
									li.nav-item(v-if="this.bankModeList.includes('MANUAL')" @click="changeTab(4)" :class="returnWidth()")
										button#depo-tab.nav-link(:class="{'active' : selectedTab === 4}" data-bs-toggle='tab' data-bs-target='#depo' type='button' role='tab' aria-controls='depo' aria-selected='true' @click="changeTab(4)")
											img.mb-2(v-if="selectedTab===4"  src="assets/img/icon07-active.svg" style="width:50px") 
											img.mb-2.grayscale(v-else src="assets/img/icon07.svg" style="width:50px") 
											div {{$t('ui.manual_deposit')}}
									li.nav-item(role='presentation' v-if="this.bankModeList.includes('gcash')" @click="changeTab(0)" :class="returnWidth()")
										button#gcash-tab.nav-link(:class="{'active' : selectedTab === 0}" data-bs-toggle='tab' data-bs-target='#gcash' type='button' role='tab' aria-controls='gcash' aria-selected='false' @click="changeTab(0)") 
											img.mb-2(:class="{'grayscale': selectedTab !== 0}" src="assets/img/GCash.png" style="width:50px") 
											div GCASH
									li.nav-item(role='presentation' v-if="this.bankModeList.includes('gcashqr')" @click="changeTab(1)" :class="returnWidth()")
										button#gcashqr-tab.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#gcashqr' type='button' role='tab' aria-controls='gcashqr' aria-selected='false' @click="changeTab(1)") 
											img.mb-2(:class="{'grayscale': selectedTab !== 1}" src="assets/img/GCash.png" style="width:50px") 
											div GCASH QR
									li.nav-item(role='presentation' v-if="this.bankModeList.includes('maya')" @click="changeTab(2)" :class="returnWidth()")
										button#maya-tab.nav-link(:class="{'active' : selectedTab === 2}" data-bs-toggle='tab' data-bs-target='#maya' type='button' role='tab' aria-controls='maya' aria-selected='false' @click="changeTab(2)") 
											img.mb-2(:class="{'grayscale': selectedTab !== 2}" src="assets/img/Maya.png" style="width:50px") 
											div MAYA
								.tab-content
									//- manualDeposit(v-if="selectedTab === 4" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList")
									gcash(v-if="selectedTab === 0" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="gcashChannel")
									gcashqr(v-if="selectedTab === 1" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="gcashqrChannel")
									maya(v-if="selectedTab === 2" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="mayaChannel")
									grab(v-if="selectedTab === 3" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="grabChannel")
									usdt(v-if="selectedTab === 4" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="usdtChannel")
									bank(v-if="selectedTab === 5" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="bankChannel")
									qrph(v-if="selectedTab === 6" :minSettingDeposit="minDeposit" :operatorBankList="operatorBankList" :promotionList="promoList" :providerList="qrphChannel")
</template>
<script>
// import manualDeposit from '@/component/payment/_manualDeposit.vue'
import gcash from '@/component/payment/_gcash.vue'
import gcashqr from '@/component/payment/_gcashqr.vue'
import maya from '@/component/payment/_maya.vue'
import grab from '@/component/payment/_grabPay.vue'
import usdt from '@/component/payment/_usdt.vue'
import bank from '@/component/payment/_bank.vue'
import qrph from '@/component/payment/_qrph.vue'
export default {
	components:{
		// manualDeposit,
		gcash,
		gcashqr,
		maya,
		grab,
		usdt,
		bank,
		qrph
		// balance
	},
	data(){
		return{
			conditionChecked: false,
			loading: false,
      feedback: {
        success: true,
        status: ""
      },
			selectedTab: "",
			bankModeList: [],
			minDeposit: 0,
			// minWithdrawal: 0,
      promoList: [],
      operatorBankList: [],
			gcashChannel: [],
			gcashqrChannel: [],
			mayaChannel: [],
			grabChannel: [],
			usdtChannel:[],
			bankChannel: [],
			qrphChannel: [],
			slideState: 0
		}
	},
	computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
	watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
	created(){
		if(this.$store.getters.isLoggedIn){
			this.getBankingMode();
		}
	},
	mounted(){
		window.scrollTo(0, 0)
		var vm = this
		$('.payment-mode ul').on('afterChange', function(event, slick, currentSlide){
			vm.slideState = currentSlide
    });

	},
	methods:{
		// returnWidth(){
		// 	var size = this.bankModeList.length
		// 	switch(size){
		// 		case 1:
		// 			return "w-100"
		// 		case 2:
		// 			return "duo-display"
		// 		case 3:
		// 			return "trio-display"
		// 		case 4:
		// 			return "quad-display"
		// 		case 5:
		// 			return "pent-display"
		// 		case 6:
		// 			return "hex-display"
		// 		case 7: 
		// 			return "hepta-display"
		// 		default:
		// 			return "" 
		// 	}
		// },
		changeTab(option){
			if(option === this.selectedTab){
				return;
			}else{
				this.selectedTab = option
			}
		},
		getBankingMode() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBankingMode", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              let bankMode = response.data.payment_mode
              bankMode.forEach(y => {
								// this.bankModeList.push(y.payment_mode)
								this.bankModeList.push({
									"payment_mode": y.payment_mode,
									"payment_desc": y.payment_desc
								})
              })
							let paymentChannel = response.data.payment_mode_loop
							paymentChannel.forEach(y => {
								if(y.payment_mode === "gcash"){
									this.gcashChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "gcashqr"){
									this.gcashqrChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "maya"){
									this.mayaChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "grabpay"){
									this.grabChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "usdt"){
									this.usdtChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "bank"){
									this.bankChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
								if(y.payment_mode === "qrph"){
									this.qrphChannel.push({
										provider_group: y.provider_group,
										is_recommend: y.is_recommend,
										min_limit: y.min_limit,
										max_limit: y.max_limit
									})
								}
              })
							
							if(this.bankModeList.length > 0){
								if(this.bankModeList[0].payment_mode === 'gcash'){
									this.selectedTab = 0
								}
								if(this.bankModeList[0].payment_mode === 'gcashqr'){
									this.selectedTab= 1
								}
								if(this.bankModeList[0].payment_mode === 'maya'){
									this.selectedTab= 2
								}
								if(this.bankModeList[0].payment_mode === 'grabpay'){
									this.selectedTab= 3
								}
								if(this.bankModeList[0].payment_mode === 'usdt'){
									this.selectedTab= 4
								}
								if(this.bankModeList[0].payment_mode === 'bank'){
									this.selectedTab= 5
								}
								if(this.bankModeList[0].payment_mode === 'qrph'){
									this.selectedTab= 6
								}
							}
							
              // if(this.bankModeList.includes('MANUAL')){
              //   this.selectedTab= 4
              // }else{
							// 	if(this.bankModeList.includes('gcash')){
							// 		this.selectedTab= 0
							// 	}else{
							// 		if(this.bankModeList.includes('gcashqr')){
							// 			this.selectedTab= 1
							// 		}else{
							// 			if(this.bankModeList.includes('maya')){
							// 				this.selectedTab= 2
							// 			}else{
							// 				// if(this.bankModeList.includes('RMPAY')){
							// 				// 	this.selectedTab= 3
							// 				// }	
							// 			}                   
							// 		} 
							// 	}
                                
              // }             
              this.minDeposit = (response.data.min_setting.filter(item => item.setting_key === "min_deposit"))[0].setting_value
              this.operatorBankList = response.data.operator_deposit_bank_list
              this.promoList = response.data.promotion_list
              // this.promoList.sort((a, b) => (a.promo_id > b.promo_id) ? 1 : (a.promo_id === b.promo_id) ? ((a.package_amount > b.package_amount) ? 1 : -1) : -1 )
							this.promoList.sort((a, b) => (a.promo_id > b.promo_id) ? 1 : ((b.promo_id > a.promo_id) ? ((a.package_amount > b.package_amount) ? 1 : -1) : 0))
							
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
							
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
						
          });
      }
    }
	}
}
</script>
<style lang="scss" scoped>
.duo-display{
	width: 50% !important;
}
.trio-display{
  width: 33.33% !important
}
.quad-display{
  width: 25% !important
}
.pent-display{
  width: 20% !important
}
.hex-display{
  width: 16.66% !important
}
.hepta-display{
	width: 14.2857% !important
}
.deposit-container{
	border-right: 1px solid #5C4180;
}
.withdrawal-container{
	color: inherit;
  text-decoration: inherit;
}
button{
	height: 100%;
}
.payment-mode .slick-prev:before, .payment-mode .slick-next:before { font-family: FontAwesome; font-size: 38px; line-height: 1; -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }   
.payment-mode .slick-prev, .payment-mode .slick-next {top:40%;}
.payment-mode .slick-prev.slick-disabled:before, .payment-mode .slick-next.slick-disabled:before { opacity:0;}
.payment-mode .slick-prev:before { content: "\f053"; }
.payment-mode .slick-next:before { content: "\f054"; }

.resbox-tabs .nav-tabs {
	background-color: #33244a;
	color: #ffffff;
	flex-wrap: nowrap;
	border-bottom: 1px solid #7a18a5;
	display: flex;
	flex-wrap: wrap;
}
.resbox-tabs .nav-tabs .nav-item {
	width: 25%;
	@media(min-width: 681px ){
		width: 16.66%;
	}
	@media(min-width: 1081px){
		width: 14.285%;
	}
}
.resbox-tabs .nav-tabs .nav-item.show .nav-link, .resbox-tabs .nav-tabs .nav-link.active {
	background-color: #7a18a5;
	filter: grayscale(0);
}
.resbox-tabs .nav-tabs .nav-link {
	border: 0;
	border-radius: 0;
	width: 100%;
	text-align: center;
	text-transform: uppercase;
	color: #ffffff;
	font-weight: bold;
	margin: 0;
	padding: 8px 0;
	filter: grayscale(1);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.resbox-tabs .nav-tabs .nav-link img {
	max-width: 48px;
	margin-bottom: 2px;
}
.resbox-tabs .nav-tabs .nav-link span {
	font-size: 12px;
}
.resbox-tabs .tab-content{
	@media(max-width: 680px) {
		padding: 0 !important
	}
}
</style>